// src/theme.ts
import { extendTheme } from '@chakra-ui/react'

const pretendard = `'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif`

const theme = extendTheme({
  fonts: {
    heading: pretendard,
    body: pretendard,
    mono: pretendard
  },
  styles: {
    global: {
      'html, body': {
        fontFamily: pretendard,
        fontWeight: '600'
      },
      '*': {
        fontFamily: pretendard,
        fontWeight: '600'
      }
    }
  },
  colors: {
    brand: {
      50: '#FDF2F0', // 매우 밝은 레드 브라운 (배경용)
      100: '#F9D9D3', // 밝은 파스텔 레드 브라운
      200: '#F2B5A8', // 연한 레드 브라운
      300: '#E88F7A', // 부드러운 중간 레드 브라운
      400: '#D66A4F', // 좀 더 강한 레드 브라운
      500: '#A74230', // 기준 색상 (포인트 컬러)
      600: '#8B3626', // 살짝 어두운 레드 브라운
      700: '#6D2A1D', // 채도를 낮춘 중간톤 레드 브라운
      800: '#4F1F15', // 어두운 레드 브라운
      900: '#31140D' // 가장 어두운 레드 브라운
    },
    orange: {
      50: '#FFF8E1', // 매우 밝은 옐로우 (배경용)
      100: '#FFECB3', // 밝은 파스텔 옐로우
      200: '#FFE082', // 연한 골드 느낌
      300: '#FFD54F', // 부드러운 중간 골드
      400: '#FFCA28', // 좀 더 강한 골드
      500: '#F6C019', // 기준 색상 (중심 골드)
      600: '#FFCA28', // 살짝 어두운 골드
      700: '#B38712', // 채도를 낮춘 중간톤 골드
      800: '#926E0D', // 어두운 머스터드 느낌
      900: '#715609' // 가장 어두운 황금 브라운
    }
  }
})

export default theme
